export default __webpack_public_path__ + "static/media/sidebar-logo.fcdddcd3.png";